import { Component, forwardRef } from '@angular/core';
import { BaseFormComponent } from '../../global/BaseFormComponent';
import { FormGroup, FormControl, Validators, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PatternValidator } from '../../global/Validators';
import { UrlValidator } from 'src/app/validators/url-validator'
import { PhoneAreaCodeValidator } from 'src/app/validators/phone-area-code-validator'

@Component({
  standalone: false,
  selector: 'app-channels-form',
  templateUrl: './channels-form.component.html',
  styleUrls: ['./channels-form.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ChannelsFormComponent),
    multi: true
  }]
})

export class ChannelsFormComponent extends BaseFormComponent {



  constructor(private urlValidator: UrlValidator, private phoneAreaCodeValidator: PhoneAreaCodeValidator) {
    super();

    this.form = new FormGroup({
      website: new FormControl('', [
        Validators.required,
        PatternValidator.url(),
        this.urlValidator.validateUrl()
      ]),
      phone: new FormControl('', [
        PatternValidator.phone(),
        phoneAreaCodeValidator.validateAreaCode()
      ])
    });


    this.onValueChanged(p => {
      this.setValues(p.website as string, p.phone as string);
    });


    this.form.valueChanges.subscribe(values => {
      this.value.website = values.website;
      this.value.phone = values.phone;
    });
  }


  setValues(website: string, phone: string): void {
    this.form.get('website').setValue(website);
    this.form.get('phone').setValue(phone);
  }


}
